module.exports = __webpack_public_path__ + "img/global-not_network.png?31b33480";